const LiteratureUtils = {
    // This function takes the categories and a literature row, and returns the label for the category of that row
    renderCategoryLabel(categories, row) {
	if (!categories || categories.length === 0) {
		return "Loading...";
	}

	const categoryLabel = categories.find(
		(cat) => cat.literatureCategoryValue === row.literatureCategory
	);

	return categoryLabel ? categoryLabel.literatureCategoryLabel : "Unknown Category";
   },
  // This function formats the ACMG evidence criteria by splitting on commas and trimming whitespace, then joining back with a comma and space
   formattedLitEval(row) {
    return row.acmgEvidCriteriaId
        ? row.acmgEvidCriteriaId.split(',').map(s => s.trim()).join(', ')
        : '';
   },

};

export default LiteratureUtils;